// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1iCJ9","active":"downloadDropdown_active__JtPz5"};